<template>
  <div>
    <sub-header-component
      :title="getLocalized(contentData, 'title')"
      :description="getLocalized(contentData, 'description')"
    ></sub-header-component>
    <div class="p-6 md:p-[100px]">
      <div class="flex flex-col gap-4 md:gap-[40px]">
        <!-- Computer & Accessories Card -->
        <div
          class="w-full lg:h-full md:rounded-[20px] md:p-[40px] flex flex-col gap-[10px] bg-white mx-auto"
        >
          <div
            class="w-full h-full flex flex-col gap-4 md:gap-[40px] rounded-[16px]"
          >
            <img
              class="w-full md:h-[600px] object-cover md:rounded-[16px] md:p-[10px] md:gap-[10px]"
              :src="ispData.image_path"
              alt=""
            />
            <div
              class="flex flex-col gap-[20px] p-4 md:p-0 text-start md:text-center"
            >
              <h1 class="font-bold text-xl md:text-4xl">
                {{ getLocalized(ispData, "name") }}
              </h1>
              <p class="text-lg md:text-2xl">
                {{ getLocalized(ispData, "description") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "@splidejs/splide/css";
import { useLocalization } from "@/composable/useLocalization";
import subHeaderComponent from "./subHeaderComponent.vue";
import Patern from "@/assets/pictures/patern.png";
import frameCircle from "@/assets/pictures/frameCircle.png";
import { fetchContentSection } from "@/composable/apiService";

export default {
  components: { subHeaderComponent },
  data() {
    return {
      Patern: Patern,
      frameCircle: frameCircle,
      api: process.env.VUE_APP_API_KEY,
      ispData: {},
      contentData: {},
      splide: null,
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  mounted() {
    this.fetchISP();
  },
  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  methods: {
    async fetchISP() {
      try {
        this.contentData = await fetchContentSection(7);
        const response = await axios.get(
          this.api + "/api/sub-services/?return_all=true"
        );
        this.ispData = response.data.items
          .map((item) => ({
            ...item,
            image_path: `${this.api}${item.image_path}`,
          }))
          .find((item) => item.id === 20);
        console.log(this.ispData);
      } catch (error) {
        console.error(error.message);
      }
    },
  },
};
</script>

<style scoped>
/* Optional styles for inactive state (gray background and black text) */
.bg-gray-200 {
  background-color: #f3f4f6; /* Example gray color */
}

@media (min-width: 300px) and (max-width: 400px) {
  .btnForSmall {
    padding: 2px 4px;
    font-size: 8px;
  }
  .btnSpeed {
    padding: 2px 10px;
    font-size: 10px;
  }
  .smallText {
    font-size: 16px;
  }
  .gapSmallDevice {
    margin-top: 5px;
  }
}
</style>
